import React from 'react';


// Icon
import { ArrowBack, Search, ShoppingCart } from '@material-ui/icons'

// Material-UI
import { InputBase, IconButton, Badge } from '@material-ui/core'

// Components
import Gap from '../../../atoms/Gap'

// Styles
import useStyles from './style'

// Router
import { Link, useHistory } from 'react-router-dom'

function WithSearchBack({ onClick, value, placeholder, onChange, totalCart, onBack}) {

    const classes = useStyles()

    const history = useHistory()

    return (
        <div
            className={classes.root}
        >
            <IconButton
                size="small"
                onClick={onBack}
            >
                <ArrowBack className={classes.icon} />
            </IconButton>
            <Gap width={16} />
            <div className={classes.searchBox}>
                <Search className={classes.icSearch} />
                <Gap width={10} />
                <InputBase
                    placeholder={placeholder}
                    value={value}
                    inputProps={{ 'aria-label': placeholder }}
                    onChange={onChange}
                    fullWidth
                    autoFocus
                />
            </div>
            <Gap width={16} />
            <IconButton
                onClick={() => history.push('/cart')}
                size="small"
            >
                <Badge badgeContent={totalCart} color="secondary">
                    <ShoppingCart className={classes.icon} />
                </Badge>
            </IconButton>
        </div>
    )
}

export default WithSearchBack
